import React from 'react';

export class KpiParameterSelect extends React.PureComponent {
  renderParameter = (p) => (
    <option key={p} value={p}>
      {p}
    </option>
  );

  render() {
    const { name, parameters, parameter, canSelectNone, onChange } = this.props;
    const hasParameters = parameters && parameters.length;

    return (
      <>
        {hasParameters ? (
          <select
            name={name}
            value={parameter ? parameter : ''}
            onChange={onChange}
          >
            <option disabled={!canSelectNone} value={''}>
              None
            </option>
            {parameters.map(this.renderParameter)}
          </select>
        ) : (
          <span>No parameters available</span>
        )}
      </>
    );
  }
}
